import { useEffect, useState, useRef, useCallback } from "react";
import { Modal, Button, Table, message } from "antd";
import "antd/dist/antd.css";
import * as S from "./styles";
import api from "../../service/api";
import { useHistory } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import OpenFinanceActions from "../../components/PluggyButton/PluggyButton";
import ModalDeletarOFX from "./ModalDeletarOFX";

interface DataItem {
    key: string;
    originalFile?: File;
    id?: string;
    empresa: string;
    cnpj: string;
    banco: string;
    agencia?: string;
    conta: string;
    contaCorrente?: string;
    itemId?: string;
    dataInicial?: string;
    dataFinal?: string;
    nomeArquivo?: string;
    dataImportacao?: string;
    hash?: string;
}

export default function TablePortalAdministradoras({ currentUser }: any) {
    const history = useHistory();

    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState<DataItem[]>([]);
    const [dataFile, setDataFile] = useState<DataItem[]>([]);
    const [filteredData, setFilteredData] = useState<DataItem[]>([]);
    const [selectedCompany, setSelectedCompany] = useState<string>("");
    const [selectedBanco, setSelectedBanco] = useState<string>("");
    const [selectedConta, setSelectedConta] = useState<string>("");
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalVisibleDeletar, setIsModalVisibleDeletar] = useState(false);
    const [companyOptions, setCompanyOptions] = useState<string[]>([]);
    const [bancoOptions, setBancoOptions] = useState<string[]>([]);
    const [contaOptions, setContaOptions] = useState<string[]>([]);

    const [periodos, setPeriodos] = useState<string[]>([]);
    const [logMessages, setLogMessages] = useState<string[]>([]);

    const addLog = (msg: string) => {
        const time = new Date().toLocaleTimeString('pt-BR');
        setLogMessages(prev => [...prev, `[${time}] ${msg}`]);
    };
    const [enterprise, setEnterprise] = useState({
        key: "1",
        agencia: "teste",
        banco: "teste",
        cnpj: "teste",
        conta: "teste",
        empresa: "teste",
    });

    const handleCheckbox = (mes: string) => {
        setPeriodos(prev =>
            prev.includes(mes)
                ? prev.filter(m => m !== mes)
                : [...prev, mes]
        );
    };

    const removeRow = (keyToRemove: string) => {
        setDataFile((prevDataFile) => prevDataFile.filter((item) => item.key !== keyToRemove));
    };

    const handleImport = () => {
        fileInputRef.current?.click();
    };

    const handleGravar = async () => {
        if (dataFile.length === 0) {
            message.warning("Nenhum arquivo para gravar. Selecione arquivos OFX primeiro.");
            return;
        }
        if (periodos.length === 0) {
            message.warning("Selecione pelo menos um período (mês) para importação.");
            return;
        }

        const request = new FormData();
        const cliente = localStorage.getItem("cliente");

        if (!cliente) {
            message.error("Dados do cliente não encontrados. Impossível gravar.");
            return;
        }

        try {
            const clienteObj = JSON.parse(cliente);
            const nomeDoGrupo = clienteObj?.nomeDoGrupo;

            let filesToSendCount = 0;

            dataFile.forEach((item) => {
                if (item.originalFile instanceof File) {
                    request.append("OfxFile", item.originalFile, item.nomeArquivo);
                    filesToSendCount++;
                } else {
                    console.warn(`[handleGravar] Arquivo original inválido ou não encontrado para o item: '${item.nomeArquivo}'. Ele não será enviado.`);
                    addLog(`AVISO: Arquivo '${item.nomeArquivo}' não pôde ser preparado para gravação e foi ignorado.`);
                }
            });

            if (filesToSendCount === 0) {
                message.error("Nenhum arquivo OFX válido para gravar foi encontrado. Verifique os arquivos na lista de pré-visualização.");
                return;
            }

            const meses = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
            const periodosNumericos = periodos.map(mes => meses.indexOf(mes) + 1);

            periodosNumericos.forEach(numero => {
                request.append("Periodos", numero.toString());
            });

            request.append("Empresa", nomeDoGrupo);
            request.append("CNPJ", enterprise.cnpj);
            request.append("Banco", enterprise.banco);
            request.append("Agencia", enterprise.agencia);
            request.append("Conta", enterprise.conta);
            request.append("NomeGrupo", JSON.stringify(clienteObj));

            message.loading("Gravando arquivos, por favor aguarde...", 0);
            const response = await api.post("/Extratos/cadastrarOFX", request, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            message.destroy();

            if (response.data.sucess === true) {
                message.success(response.data.message);
                handleModalCancel();
            } else {
                addLog(`ERRO: ${response.data.message || "Erro desconhecido ao gravar."}`);
            }

        } catch (error) {
            message.destroy();
            console.error("[handleGravar] Erro ao enviar o arquivo para gravação:", error);
            addLog("ERRO: Ocorreu um erro ao gravar o arquivo. Tente novamente.");
        }
    };

    const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const cliente = localStorage.getItem("cliente");

        if (!cliente) {
            message.error("Dados do cliente não encontrados. Impossível processar arquivos.");
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            return;
        }

        const files = event.target.files;
        if (!files || files.length === 0) {
            setDataFile([]);
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            return;
        }

        const filesArray = Array.from(files);

        const originalFilesMap = new Map<string, File>();
        filesArray.forEach(file => {
            originalFilesMap.set(file.name.toLowerCase(), file);
            const baseName = file.name.split('.').slice(0, -1).join('.');
            if (baseName) {
                originalFilesMap.set(baseName.toLowerCase(), file);
            }
        });

        const clienteObj = JSON.parse(cliente);
        const nomeDoGrupo = clienteObj?.nomeDoGrupo;

        const formData = new FormData();
        formData.append("nomeGrupo", nomeDoGrupo);
        formData.append("enterprise", JSON.stringify(enterprise));
        filesArray.forEach((file) => {
            formData.append("ofxFile", file);
        });

        message.loading("Processando arquivos OFX...", 0);
        try {
            const response = await api.post("/Extratos/processarOFX", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            message.destroy();

            if (response.data.extratosProcessados && response.data.extratosProcessados.length > 0) {
                const formattedData: DataItem[] = response.data.extratosProcessados.map((item: any) => {
                    const backendFileNameLower = item.nomeArquivo ? item.nomeArquivo.toLowerCase() : '';
                    let originalFileFound: File | undefined;

                    originalFileFound = originalFilesMap.get(backendFileNameLower);

                    if (!originalFileFound && backendFileNameLower && !backendFileNameLower.endsWith('.ofx')) {
                        originalFileFound = originalFilesMap.get(`${backendFileNameLower}.ofx`);
                    }
                    if (!originalFileFound && backendFileNameLower.endsWith('.ofx')) {
                        const baseName = backendFileNameLower.split('.').slice(0, -1).join('.');
                        originalFileFound = originalFilesMap.get(baseName);
                    }

                    return {
                        key: uuidv4(),
                        originalFile: originalFileFound,
                        empresa: item.empresa,
                        cnpj: item.cnpj,
                        contaCorrente: item.contaCorrente,
                        banco: item.banco,
                        dataInicial: item.dataInicial,
                        dataFinal: item.dataFinal,
                        nomeArquivo: item.nomeArquivo,
                    };
                });

                setDataFile(prevData => [...prevData, ...formattedData]);

                message.success(`${formattedData.length} arquivo(s) processado(s) com sucesso para pré-visualização!`);
            }

            if (response.data.extratosComErro && response.data.extratosComErro.length > 0) {
                response.data.extratosComErro.forEach((item: string) => {
                    addLog(`ERRO no arquivo: ${item}`);
                });
                if (response.data.extratosProcessados && response.data.extratosProcessados.length > 0) {
                    addLog("AVISO: Alguns arquivos foram processados, mas outros contêm erros. Verifique o log abaixo.");
                } else {
                    addLog(`ERRO: ${response.data.message || "Nenhum arquivo foi processado."}`);
                }
            } else if (response.data.sucess === false) {
                addLog(`ERRO: ${response.data.message || "Ocorreu um erro inesperado ao processar os arquivos."}`);
            }

        } catch (error) {
            message.destroy();
            console.error("[handleFileUpload] Erro na comunicação com o servidor ao processar arquivos:", error);
            addLog("ERRO: Falha na comunicação com o servidor ao processar arquivos. Tente novamente.");
        } finally {
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        }
    };

    const showModal = () => {
        setDataFile([]);
        setPeriodos([]);
        setLogMessages([]);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        setIsModalVisible(true);
    };

    const handleModalCancel = () => {
        setDataFile([]);
        setPeriodos([]);
        setLogMessages([]);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        setIsModalVisible(false);
    };

    const showModalDeletar = () => {
        setIsModalVisibleDeletar(true);
    };

    const handleModalCancelDeletar = () => {
        setIsModalVisibleDeletar(false);
    };

    function openListaExtratos() {
        const cliente = localStorage.getItem('cliente');
        if (cliente) {
            const clienteObj = JSON.parse(cliente);
            const id = clienteObj?.id;
            if (id) {
                history.replace({
                    pathname: '/ListaExtratos',
                    state: { id },
                });
            }
        } else {
            message.warning("Nenhum cliente logado para ver extratos.");
        }
    }

    const handleRedirect = () => {
        history.push("/CadastroPortalAdministradoras");
    };

    useEffect(() => {
        const filtered = data.filter(item => {
            return (
                (!selectedCompany || item.empresa === selectedCompany) &&
                (!selectedBanco || item.banco === selectedBanco) &&
                (!selectedConta || item.conta === selectedConta)
            );
        });
        setFilteredData(filtered);
    }, [selectedCompany, selectedBanco, selectedConta, data]);

    useEffect(() => {
        let filteredByCompany = selectedCompany
            ? data.filter(item => item.empresa === selectedCompany)
            : data;

        const uniqueBanco = Array.from(new Set(filteredByCompany.map(item => item.banco))).filter(Boolean);
        setBancoOptions(uniqueBanco);

        let filteredByBanco = selectedBanco
            ? filteredByCompany.filter(item => item.banco === selectedBanco)
            : filteredByCompany;

        const uniqueConta = Array.from(new Set(filteredByBanco.map(item => item.conta))).filter(Boolean);
        setContaOptions(uniqueConta);

        if (selectedConta && !uniqueConta.includes(selectedConta)) {
            setSelectedConta("");
        }
        if (selectedBanco && !uniqueBanco.includes(selectedBanco) && selectedCompany) {
            setSelectedBanco("");
        }

    }, [selectedCompany, selectedBanco, data]);

    const listarExtratos = useCallback(async () => {
        const cliente = localStorage.getItem('cliente');
        if (!cliente) {
            console.warn('Cliente não encontrado no localStorage ao tentar listar extratos.');
            setIsLoading(false);
            return;
        }

        const clienteObj = JSON.parse(cliente);
        const nomeDoGrupo = clienteObj?.nomeDoGrupo;

        setIsLoading(true);

        try {
            const response = await api.get(`/Extratos/listarContasExtratos`, {
                params: { nomeDoGrupo: nomeDoGrupo },
            });
            if (response.data.success) {
                const formattedData: DataItem[] = response.data.result.map((item: any) => ({
                    key: item.id,
                    empresa: item.empresa,
                    cnpj: item.cnpj,
                    banco: item.banco,
                    agencia: item.agencia,
                    conta: item.conta,
                    contaCorrente: item.conta,
                    itemId: item.itemId
                }));

                const uniqueCompanies = Array.from(new Set(formattedData.map((item) => item.empresa))).filter(Boolean);
                setCompanyOptions(uniqueCompanies);

                setData(formattedData);
                setFilteredData(formattedData);
            } else {
                message.error("Erro ao carregar lista de extratos: " + response.data.message);
            }
        } catch (error) {
            console.error("Erro ao listar extratos:", error);
            message.error("Erro ao carregar lista de extratos.");
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        listarExtratos();
    }, [currentUser, listarExtratos]);

    const formatCNPJ = (cnpj: string) => {
        if (!cnpj) return "";
        return cnpj
            .replace(/\D/g, "")
            .replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    };

    function OpenLink(link: string) {
        const fullLink =
            link.startsWith("http://") || link.startsWith("https://")
                ? link
                : `http://${link}`;

        const win = window.open(fullLink, "_blank");
        if (win) {
            win.focus();
        } else {
            message.warning("Por favor, permita pop-ups para abrir o link.");
        }
    }

    const columns = [
        { title: "EMPRESA", dataIndex: "empresa", key: "empresa", width: 150 },
        { title: "CNPJ", dataIndex: "cnpj", key: "cnpj", width: 120, render: (cnpj: string) => formatCNPJ(cnpj) },
        { title: "BANCO", dataIndex: "banco", key: "banco", width: 150 },
        { title: "AGÊNCIA", dataIndex: "agencia", key: "agencia", width: 150 },
        { title: "CONTA CORRENTE", dataIndex: "contaCorrente", key: "contaCorrente", width: 150 },
        { title: "ItemId", dataIndex: "itemId", key: "itemId", width: 1, hidden: true },
        {
            title: "OPEN FINANCE",
            dataIndex: "id",
            key: "id",
            width: "10%",
            render: (_: any, record: DataItem) => (
                <OpenFinanceActions
                    cnpj={record.cnpj}
                    conta={record.conta}
                    grupo={record.empresa}
                    updateItemId={record.itemId}
                />
            ),
        }
    ];

    const visibleColumns = columns.filter(col => !(col as any).hidden);

    return (
        <S.Container>
            <S.DivTable>
                <S.Tools>
                    <S.SearchContainer>
                        <S.MenuContainer>
                            <select
                                value={selectedCompany}
                                onChange={(e) => {
                                    setSelectedCompany(e.target.value);
                                    setSelectedBanco("");
                                    setSelectedConta("");
                                }}
                            >
                                <option value="">Selecionar Empresa</option>
                                {companyOptions.map((option: string) => (
                                    <option key={option} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                        </S.MenuContainer>
                        <S.MenuContainer style={{ marginLeft: "10px" }}>
                            <select
                                value={selectedBanco}
                                onChange={(e) => {
                                    setSelectedBanco(e.target.value);
                                    setSelectedConta("");
                                }}
                            >
                                <option value="">Selecionar Banco</option>
                                {bancoOptions.map((banco: string) => (
                                    <option key={banco} value={banco}>
                                        {banco}
                                    </option>
                                ))}
                            </select>
                        </S.MenuContainer>
                        <S.MenuContainer style={{ marginLeft: "10px" }}>
                            <select
                                value={selectedConta}
                                onChange={(e) => setSelectedConta(e.target.value)}
                            >
                                <option value="">Selecionar Conta</option>
                                {contaOptions.map((conta: string, index: number) => (
                                    <option key={index} value={conta}>
                                        {conta}
                                    </option>
                                ))}
                            </select>
                        </S.MenuContainer>
                        <Button
                            type="primary"
                            onClick={handleRedirect}
                            style={{ float: "right", marginLeft: "10px", marginTop: `6px`, borderRadius: "4px" }}
                        >
                            Cadastrar Conta
                        </Button>
                        <Button
                            onClick={() => openListaExtratos()}
                            type="primary"
                            style={{
                                borderRadius: "4px",
                                color: "white",
                                float: "right",
                                marginLeft: "5px",
                                marginTop: "6px"
                            }}
                        >
                            Ver Extrato
                        </Button>
                    </S.SearchContainer>
                    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                        <Button
                            onClick={() => showModal()}
                            type="primary"
                            style={{
                                borderRadius: "4px",
                                backgroundColor: "#01B73A",
                                borderColor: "#01B73A",
                                color: "white",
                                marginRight: "5px",
                            }}
                        >
                            Importar OFX
                        </Button>

                        <Button
                            type="primary"
                            onClick={() => showModalDeletar()}
                            style={{
                                borderRadius: "4px",
                                backgroundColor: "#ff4d4f",
                                borderColor: "#ff7875",
                            }}
                        >
                            Deletar OFX
                        </Button>
                    </div>

                </S.Tools>
                <Table
                    pagination={{
                        pageSize: 20,
                        showSizeChanger: false,
                        showQuickJumper: false,
                    }}
                    loading={isLoading}
                    columns={visibleColumns}
                    dataSource={filteredData}
                />
            </S.DivTable>

            <Modal
                title=""
                visible={isModalVisible}
                onCancel={handleModalCancel}
                footer={null}
                width={1400}
            >
                <S.ModalHeader>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        gap: '16px',
                        flexWrap: 'nowrap'
                    }}>
                        <S.ButtonStyledSelect onClick={handleImport}>
                            <img src="./icone.png" alt="Ícone" style={{ marginRight: '8px' }} />
                            Selecionar Arquivos
                        </S.ButtonStyledSelect>

                        <div style={{
                            display: 'flex',
                            gap: '8px',
                            padding: '8px',
                            backgroundColor: '#f5f5f5',
                            borderRadius: '8px',
                            flexWrap: 'nowrap'
                        }}>
                            {["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"].map((mes, index) => (
                                <label key={index} style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '13px',
                                    fontWeight: 500,
                                    cursor: 'pointer'
                                }}>
                                    <input
                                        type="checkbox"
                                        value={mes}
                                        checked={periodos.includes(mes)}
                                        onChange={() => handleCheckbox(mes)}
                                        style={{ marginRight: '6px', accentColor: '#1677ff' }}
                                    />
                                    {mes}
                                </label>
                            ))}
                        </div>
                    </div>

                    <input
                        ref={fileInputRef}
                        type="file"
                        accept=".ofx"
                        style={{ display: "none" }}
                        id="fileInput"
                        multiple
                        onChange={handleFileUpload}
                    />
                </S.ModalHeader>

                <S.ModalContainer>
                    <Table<DataItem>
                        pagination={false}
                        bordered
                        dataSource={dataFile}
                        columns={[
                            {
                                key: "actions",
                                render: (_, record) => (
                                    <Button
                                        type="link"
                                        danger
                                        onClick={() => removeRow(record.key)}
                                    >
                                        X
                                    </Button>
                                ),
                                width: 50,
                            },
                            { title: "Empresa", dataIndex: "empresa", key: "empresa" },
                            { title: "CNPJ", dataIndex: "cnpj", key: "cnpj" },
                            { title: "Banco", dataIndex: "banco", key: "banco" },
                            {
                                title: "Conta Corrente",
                                dataIndex: "contaCorrente",
                                key: "contaCorrente",
                            },
                            {
                                title: <span style={{ fontWeight: 'bold' }}>Data Inicial</span>,
                                dataIndex: "dataInicial",
                                key: "dataInicial",
                            },
                            {
                                title: <span style={{ fontWeight: 'bold' }}>Data Final</span>,
                                dataIndex: "dataFinal",
                                key: "dataFinal",
                            },
                            {
                                title: "Nome Arquivo",
                                dataIndex: "nomeArquivo",
                                key: "nomeArquivo",
                            },
                        ]}
                    />
                    <S.Footer>
                        <S.Typography>
                            <p style={{ fontSize: "15px" }}>
                                ATENÇÃO: Verifique se
                                <b style={{ fontFamily: "" }}> Data Inicial </b> e <b>Final </b>
                                estão corretas antes de importar.
                            </p>
                        </S.Typography>
                        <S.Actions>
                            <S.ButtonStyledBlue onClick={handleGravar}>
                                Gravar
                            </S.ButtonStyledBlue>
                            <S.ButtonStyled onClick={handleModalCancel}>
                                Cancelar
                            </S.ButtonStyled>
                        </S.Actions>
                    </S.Footer>
                    {logMessages.length > 0 && (
                        <div>
                            <div style={{ fontSize: '13px', fontWeight: 600, marginBottom: '4px', color: '#595959' }}>
                                Log de erros:
                            </div>
                            <textarea
                                readOnly
                                value={logMessages.join('\n')}
                                style={{
                                    width: '100%',
                                    height: '120px',
                                    fontSize: '12px',
                                    fontFamily: 'monospace',
                                    resize: 'vertical',
                                    border: '1px solid #d9d9d9',
                                    borderRadius: '4px',
                                    padding: '8px',
                                    backgroundColor: '#fafafa',
                                    color: '#333',
                                    boxSizing: 'border-box',
                                }}
                            />
                        </div>
                    )}
                </S.ModalContainer>
            </Modal>

            <ModalDeletarOFX
                visible={isModalVisibleDeletar}
                onClose={handleModalCancelDeletar}
            />
        </S.Container >
    );
}